export const GoodsFormOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: "200",
    labelWidth: "150",
    defaultSort: {
      prop: "createTime",
      order: "descending",
    },
    column: [
      {
        label: "产品名称",
        prop: "name",
        type: "input",
        search: true,
        span: 13,
      },
      {
        label: "产品积分",
        prop: "points",
        type: "input",
        span: 13,
      },
    ],
  };
  